import classNames from "classnames";
import Button from "../../custom/button/button";
import styles from "./main.module.scss";
import { baseUrl } from "../../requests";
import { useAtomValue } from "jotai";
import { trainingPayment, userData } from "../../state";
import { formatCurrency } from "../../utils/formatCurrency";
import usePayment from "../../hooks/usePayment";

const PayForTraining = ({
  hasUserRegistered,
  setIsEventScheduled,
  amount,
  dataId,
}: {
  hasUserRegistered?: boolean;
  setIsEventScheduled: React.Dispatch<React.SetStateAction<boolean>>;
  amount: number;
  dataId: number;
}) => {
  const { makePayment, isPending } = usePayment();
  const user = useAtomValue(userData);
  const trainingPaymentDetails = useAtomValue(trainingPayment);

  const handlePayment = async () => {
    const payload: ProcessPaymentPayload = {
      RouteId: user?.MembershipTypeId!,
      MembershipNo: user?.MemberId!,
      Amount: amount || trainingPaymentDetails?.Amount,
      Description: "Training Payment",
      ReturnURL: `${baseUrl}/event-application/training`,
      PaymentForm: "Training",
      DataId: dataId ? `${dataId}` : trainingPaymentDetails?.DataId!,
    };
    makePayment(payload, (data) => {
      const responseData = JSON.parse(data?.ResponsePayLoad) as PaymentDetails;
      // if (!trainingPaymentDetails?.IsCorporateSponsor) {
      //   setIsEventScheduled(true);
      // }
      window.location.href = responseData?.RedirectURL;
    });
  };

  return (
    <section className={classNames("card")}>
      <h2>Pay for Training</h2>
      <div className={styles.line}></div>
      {hasUserRegistered ? (
        <p>
          Looks like you've registered for this event but have not completed
          payment. Proceed to pay{" "}
          <b>
            {amount
              ? formatCurrency(amount)
              : formatCurrency(trainingPaymentDetails?.Amount)}
          </b>{" "}
          before the event date.
        </p>
      ) : (
        <p>
          You are one step away to complete your training registration. Proceed
          to pay{" "}
          <b>
            {amount
              ? formatCurrency(amount)
              : formatCurrency(trainingPaymentDetails?.Amount)}
          </b>{" "}
          before the event date.
        </p>
      )}
      <br />
      <Button
        isLoading={isPending}
        disabled={isPending}
        onClick={handlePayment}
        type="button"
        text="Make Payment"
      />
    </section>
  );
};

export default PayForTraining;
